/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Keen_Boar_WaveInputs */

const fr_plain_keen_boar_wave = /** @type {(inputs: Plain_Keen_Boar_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès aux types d'événements`)
};

/**

* @param {Plain_Keen_Boar_WaveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plain_keen_boar_wave = /** @type {((inputs?: Plain_Keen_Boar_WaveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Keen_Boar_WaveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plain_keen_boar_wave(inputs)
});